// Effective unidentified-return policy for a warehouse. Single source of truth
// for both Returns screens (list scan gate + search submit guard) — keep it here,
// never inline, so the two gates can't drift.
//
// The flag is a BRAZIL-ONLY kill switch: it exists so a BR warehouse stays dark
// until fiscal sign-off flips it. Non-BR warehouses were never meant to be gated
// (the platform serializer is specified to always emit true for them), so the
// flag is not read outside BR at all.
//
//   BR                -> use the flag (absent -> blocked, matching the dark default)
//   any other country -> enabled; the flag is not a policy input outside BR
//
// GET /warehouses/:id is not a dependency this gate can count on: it can be slow,
// fail, or 403 for some roles. That is what actually blocked reception at ENEA
// (Chile) — with no warehouse loaded the policy fell through to its fail-closed
// default and the banner blamed a warehouse flag the WMS had never read, which
// is also why some operators got through and others did not. So callers pass
// fallbackCountry: the country already resolved in UserContext
// (user.current_warehouse.country, populated from /warehouses_open). The country
// alone is enough for every non-BR warehouse, which is the whole point — no
// country outside BR is gated.
//
//   warehouse missing, fallback country known and not BR -> enabled
//   warehouse missing, fallback country BR or unknown    -> fail closed (a stray
//     "cannot verify" banner beats a BR scan slipping through this gate)
export const isUnidentifiedReturnsEnabled = (warehouse, fallbackCountry = null) => {
    const country = warehouse?.country ?? fallbackCountry
    if (country === 'BR') return warehouse?.unidentified_returns_enabled ?? false
    if (warehouse) return true // loaded and not BR — no flag involved
    return !!country // not loaded: trust the country resolved in UserContext
}
